import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { EncryptionService } from 'src/app/service/encryption.service';
import { StorageService } from 'src/app/service/storage.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
import { DataLoginService } from 'src/app/service/dataLogin.service';
import { CleverTapService } from 'src/app/service/clevertap.service';
import clevertap from 'clevertap-web-sdk';
import { isString } from 'underscore';
import { take } from 'rxjs/operators';

declare global {
  interface Window {
    openTicketsTab: () => void;
  }
}
@Component({
  selector: 'app-header-search-bar',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './header-search-bar.component.html',
  styleUrls: ['./header-search-bar.component.less']
})

export class HeaderSearchBarComponent {

  searchListArray: Array<{ id: string; title: string; permalink: string; category: { id: string } } | string> = [];
  showLoader = false;
  showResults = false;
  emailId: string;
  userName: string;
  jwtToken: string;
  isLoggedIn: string;
  accessToken: string;
  mainCategory: string;
  subCategory : string;
  private searchRequestId = 0;

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private http: HttpClient,
    private forumApiService: ForumApiService,
    private fb: FormBuilder,
    private encryptionService: EncryptionService,
    private storageService: StorageService,
    private router: Router,
    private dataService: DataService,
    public constantService: ConstantService,
    private dataLoginService: DataLoginService,
    private cleverTapService: CleverTapService,
  ) { }

  ngOnInit(): void {
    const clientName = this.encryptionService.decryptUsingAES_256(this.storageService.getItem("clientName"));
    this.dataLoginService.data.subscribe((checkLogin) => {
      if(checkLogin === this.constantService.yes){
        this.isLoggedIn = checkLogin;
        if (isString(clientName)) {
          try {
            this.userName = clientName
          } catch (error) {
            console.error('Decryption failed:', error);
            this.userName = null;
          }
        } else {
          console.log('No ClientName found in localStorage');
          this.userName = null;
        }
      } else {
        this.isLoggedIn = this.constantService.no;
        this.userName = null;
      }
    });
    
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
  }

  searchForm = this.fb.group({
    searchText: [null]
  });

  get f() {
    return this.searchForm.controls;
  }

  omit_special_char(event){
    try {
      var k;  
      k = event.charCode;
      return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 63 || (k >= 48 && k <= 57)); 
    } catch (e) {
      console.log('Error in omit special char method - ', e);
      return false;
    }
  }

  async searchByString(): Promise<void> {
    const requestId = ++this.searchRequestId;

    try {
      const searchStr = (this.searchForm.controls.searchText.value ?? '').trim();

      if (!searchStr) {
        this.searchListArray = [];
        this.showResults = false;
        return;
      }

      const portalId = this.encryptionService.decryptUsingAES_256(
        this.storageService.getItem(this.constantService.portalId)
      );
      const from = this.constantService.searchByStringRequestConstant.from;
      const limit = this.constantService.searchByStringRequestConstant.limit;
      const locale = this.constantService.searchByStringRequestConstant.englishLanguage;

      const searchByStringResponse = await this.forumApiService.searchByString(
        portalId,
        searchStr,
        from,
        limit,
        locale
      );

      if (requestId !== this.searchRequestId) {
        return;
      }

      this.setSearchResults(searchByStringResponse);
    } catch (e) {
      if (requestId !== this.searchRequestId) {
        return;
      }

      console.group('Error Occured in searchByString : ', e);
      this.searchListArray = [this.constantService.noResultFoundText];
      this.showResults = true;
    }
  }

  private setSearchResults(searchByStringResponse: any): void {
    const results = Array.isArray(searchByStringResponse?.data)
      ? searchByStringResponse.data.filter((item) => item?.title?.trim())
      : [];

    if (results.length) {
      this.searchListArray = results;
      this.showResults = true;
      return;
    }

    this.searchListArray = [this.constantService.noResultFoundText];
    this.showResults = true;
  }

  isSearchResultItem(item: unknown): item is { id: string; title: string; permalink: string; category: { id: string } } {
    return typeof item === 'object' && item !== null && 'title' in item;
  }

  onSearchInputKeydown(event: KeyboardEvent): void {
    if (!this.showResults) {
      return;
    }

    const resultButtons = this.getResultButtons();

    if (event.key === 'ArrowDown' && resultButtons.length) {
      event.preventDefault();
      resultButtons[0].focus();
    } else if (event.key === 'Escape') {
      this.showResults = false;
    }
  }

  onResultKeydown(event: KeyboardEvent, index: number): void {
    const resultButtons = this.getResultButtons();

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      resultButtons[index + 1]?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (index === 0) {
        document.getElementById('faq-search-input')?.focus();
      } else {
        resultButtons[index - 1]?.focus();
      }
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.showResults = false;
      document.getElementById('faq-search-input')?.focus();
    }
  }

  private getResultButtons(): HTMLButtonElement[] {
    return Array.from(document.querySelectorAll('#faq-search-results .result-item'));
  }

  goTosubCategoryAnswers(questionId: string, catId: string, questionTitle:string, fullQuestion: string): void {
    this.showResults = false;

    if(this.storageService.getItem(this.constantService.isLoggedIn) == this.constantService.yes) {
      
      clevertap.init('R74-5R4-6W5Z');

      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity":clientId
          }
        });        
        let clevertapData = {
          action : 'search',
          page_section : 'search',
          keyword : this.searchForm.controls.searchText.value,      
          selected_faq : fullQuestion, 
          client_code : clientId
        };    
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);          
      }, 3000);  
    }

    this.dataService.data.pipe(take(1)).subscribe((mainCategoryArray) => {
      if (!Array.isArray(mainCategoryArray)) {
        return;
      }

      for (const mainCat of mainCategoryArray) {
        for (const subCat of mainCat?.child ?? []) {
          if (subCat.id == catId) {
            this.mainCategory = mainCat.permalink;
            this.subCategory = subCat.permalink;
            break;
          }
        }
      }

      this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
    });
  }

  goToViewTicket(): void {
    this.router.navigateByUrl(this.constantService.navigationComponentPage.viewTicket);
  }

  openTicketAndCleverTapEvent() {
    try {
      window.openTicketsTab();
      this.addCleverTapEvent();
    } catch(e) {
      console.log('Error Occured in openTicketAndCleverTapEvent : ', e);
    }
  }

  addCleverTapEvent() {
    try {
      this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    if(this.isLoggedIn == this.constantService.yes) {
      clevertap.init('R74-5R4-6W5Z');
      setTimeout(() => {
        const clientId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.clientCode));
        clevertap.onUserLogin.push({
          "Site": {
              "Identity": clientId
          }
        });
        let clevertapData = {
          action : 'track_ticket',
          page_section : 'support',
          client_code : clientId
        };
        this.cleverTapService.clevertapCommonFunction('faq_page_click',clevertapData);
      }, 3000);
      
    }
    } catch (e) {
      console.log('Error in addCleverTapEvent - ', e);
    }
  }

}